<script lang="ts" setup>
import PalletIcon from "@/assets/images/pallet.svg";
import WeightIcon from "@/assets/images/weight.svg";
import type { OrderFreightDto } from "@/api/orders/dto/order.dto";
import { computed } from "vue";
import { OrderFreightType } from "@/constants/order";

const props = defineProps<{
  freights: OrderFreightDto[];
}>();

const quantityPieces = computed(() => {
  return props.freights.reduce(
    (sum, f) => sum + (f.type === OrderFreightType.pieces && !f.isDeleted ? f.quantity : 0),
    0,
  );
});

const quantityPallets = computed(() => {
  return props.freights.reduce(
    (sum, f) => sum + (f.type === OrderFreightType.pallets && !f.isDeleted ? f.quantity : 0),
    0,
  );
});

const weight = computed(() => {
  return props.freights.reduce((sum, f) => sum + (!f.isDeleted ? f.weight : 0), 0);
});
</script>

<template>
  <div class="d-flex align-center mt-6 text-grey-darken-2 font-weight-500">
    <pallet-icon />
    <div class="ml-2" data-qa="trip-stops-freight-quantity">
      <div v-if="quantityPallets">{{ quantityPallets }} pallets</div>
      <div v-if="quantityPieces">{{ quantityPieces }} pieces</div>
    </div>
    <weight-icon class="ml-4" />
    <div class="ml-2" data-qa="trip-stops-freight-weight">{{ weight }} lbs</div>
  </div>
</template>

<style lang="scss" scoped></style>
